<template>
  <div class="offers_list_header news_list_header flex column">
    <BreadCrumb />

    <div class="news_list_header__searchbox container wc-lg flex column">
      <h1 class="f-38 bold uppercase">{{ $fn.tr("შეთავაზებები") }}</h1>
      <span class="f-18 bold uppercase"
        >{{ $fn.tr("აირჩიეთ კატეგორია") }}:</span
      >
      <div class="news_list_header__searchbox--inner flex j_sb">
        <div class="news_list_header--tags flex">
          <div
            class="news_list_header--tag  br-6 bg_gray pointer flex a_center"
            v-for="(tag, index) in tags"
            :key="index"
            @click="filter_by_tag(tag.id, $event)"
          >
            <h2 class="f-14 medium">{{ _.get(tag, "title") }}</h2>
            <div class="news_list_header--tag__x">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16.97"
                height="16.97"
                viewBox="0 0 16.97 16.97"
              >
                <path
                  id="Combined_Shape"
                  data-name="Combined Shape"
                  d="M5,11V7H1A1,1,0,0,1,1,5H5V1A1,1,0,0,1,7,1V5h4a1,1,0,0,1,0,2H7v4a1,1,0,0,1-2,0Z"
                  transform="translate(8.485 16.97) rotate(-135)"
                  fill="#fff"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="news_list_header--search_wrapper">
          <el-input
            :placeholder="$fn.tr('ძიება...')"
            @focus="is_focused()"
            @blur="is_blurred()"
            v-model="search_val"
          >
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/smartComponents/BreadCrumb";
import fn from "@/helpers/func";
export default {
  components: {
    BreadCrumb
  },
  data() {
    return {
      search_val: ""
    };
  },
  props: ["content", "unic_id"],
  mounted() {
    console.log(this.$store.state.main.offers_content);
    this.$store.state.main.current_page = 1;
  },
  computed: {
    tags() {
      return this.$store.state.main.indx.terms.tags_offers;
    }
  },
  methods: {
    is_focused() {
      let el = document.querySelector(".el-input");
      el.classList.add("in_focus");
    },
    is_blurred() {
      let el = document.querySelector(".el-input");
      if (this.search_val.length == 0) {
        el.classList.remove("in_focus");
      }
    },
    choose_categories(title, event) {
      let a = document.querySelector(".active_cat");
      this.$store.state.main.offers_search_keywords = "";
      this.search_val = "";
      if (a) a.classList.remove("active_cat");
      event.currentTarget.classList.add("active_cat");
      console.log(title.id);
      this.$store.state.main.selected_main_tag = title.id;
      this.$store.state.main.offers_filter_values = [];
      this.$store.state.main.offers_filter_values.unshift(
        this.$store.state.main.selected_main_tag
      );
      this.$store.state.main.current_page = 0;

      this.search();
    },

    filter_by_tag(tag, event) {
      this.$store.state.main.trigger_update = !this.$store.state.main
        .trigger_update;
      this.search_val = "";
      if (!this.$store.state.main.offers_filter_values.includes(tag)) {
        this.$store.state.main.offers_filter_values = [];
        this.$store.state.main.offers_filter_values.unshift(
          this.$store.state.main.selected_main_tag
        );
        let slctd = document.querySelector(".news_list_header--tag.selected");
        if (slctd) slctd.classList.remove("selected");
        this.$store.state.main.offers_filter_values.push(tag);
        this.$store.state.main.current_page = 0;
        this.search();
        event.currentTarget.classList.add("selected");
      } else {
        this.$store.state.main.offers_filter_values = this.$store.state.main.offers_filter_values.filter(
          val => val !== tag
        );
        this.$store.state.main.current_page = 0;
        this.search();
        event.currentTarget.classList.remove("selected");
      }
    },

    async search(key_words) {
      this.$store.state.main.current_page = 0;
      this.$store.state.main.current_page =
        this.$store.state.main.current_page + 1;
      let params = {
        id: _.get(this.$store.state.main.selected_menu, "id"),
        componentUnicId: this.unic_id,
        searchText: key_words,
        searchTerms: this.$store.state.main.offers_filter_values,
        pageNumber: this.$store.state.main.current_page,
        perPage: parseInt(this.$store.state.main.offers_page_count)
      };
      let res = await fn.postData("main/getDataList", params);
      this.$store.state.main.offers_listCount = res.data.listCount;
      this.$store.state.main.offers_content = res.data.list;
    }
  },
  watch: {
    search_val(ns, os) {
      if (ns.length >= 3) {
        this.$store.state.main.trigger_update = !this.$store.state.main
          .trigger_update;
        this.$store.state.main.offers_search_keywords = ns;
        this.$store.state.main.current_page = 0;
        this.search(ns);
      } else {
        this.$store.state.main.current_page = 1;
        this.$store.state.main.offers_search_keywords = "";
        this.search();
      }
    }
  }
};
</script>
